import { SecureImage } from "@components/SecureImage";
import styles from './style.module.css';

export default function ImageModal({
  imageUrl,
}) {

  return (
    <div className={styles.imageModal}>
        <SecureImage imageUrl={imageUrl} />
    </div>
  );
}
